import styled, { css } from 'styled-components';

const reset = css`
  border-spacing: 0;
  font-weight: inherit;
  border-color: inherit;
  border-collapse: inherit;
  vertical-align: inherit;
  -webkit-border-horizontal-spacing: 0;
  -webkit-border-vertical-spacing: 0;
`;

export const Table = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 40px;
  border: 1px solid #dadce2;
  border-radius: 8px;
  border-radius: 8px;

  table {
    ${reset}
    width: 100%;
    min-width: 600px;
    table-layout: fixed;
    @media (max-width: 1023px) {
      table-layout: auto;
    }
    border-radius: 8px;
    border: 0;

    thead,
    tbody,
    tfoot,
    tr,
    th,
    td {
      ${reset}
      border: none;
    }

    img {
      max-width: 100%;
      height: auto;
    }

    thead {
      background-color: #dadce2;
      font-weight: bold;
    }

    tbody tr:nth-child(even) {
      background-color: #f1f1f7;
    }

    thead ~ tbody tr {
      &:nth-child(odd) {
        background-color: #f1f1f7;
      }
      &:nth-child(even) {
        background-color: #ffffff;
      }
    }

    td,
    th {
      padding: 1.625rem;
      text-align: left !important;
      border-right: 1px solid #dadce2;

      &:last-child {
        border-right: none;
      }
    }

    tbody tr {
      border-top: 1px solid #dadce2;
    }
  }
`;
